import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { useApiStore } from "@/stores/api"

export const useFeedbackStore = defineStore(
	"feedback",
	() => {
		const api = useApiStore()

		const reset = () => {
		}

		const createFeedback = async (feedback) => {
			return api.dispatchWebsiteApiCall("post", `/api/feedback`, feedback, true)
		}

		const updateFeedback = async (feedbackId, feedback) => {
			return api.dispatchWebsiteApiCall("patch", `/api/feedback/${feedbackId}`, feedback, true)
		}

		const addFeedbackImage = async (feedbackId, image) => {
			const imageResponse = await fetch(image.webPath)
			const blob = await imageResponse.blob()
			const formData = new FormData()
			formData.append('file', blob, 'image.jpg')
			return api.dispatchWebsiteApiCall("post", `/api/feedback/${feedbackId}/image`, formData, true)
		}

		return {
			reset,
			createFeedback,
			updateFeedback,
			addFeedbackImage
		}
	},
	{
		persist: true,
	}
)
